import React from 'react';
import { Home, Paintbrush, Building2, CheckCircle } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Link } from 'react-router-dom';
import { mockData } from '../mock';

const Services = () => {
  const { services } = mockData;

  const iconMap = {
    Home: Home,
    Paintbrush: Paintbrush,
    Building2: Building2
  };

  const benefits = [
    'Equipo profesional certificado',
    'Materiales de primera calidad',
    'Garantía en todos nuestros trabajos',
    'Presupuestos sin compromiso',
    'Cumplimiento de plazos',
    'Atención personalizada'
  ];

  return (
    <div className="min-h-screen pt-28 pb-20">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-[#0057CB] to-[#38B6FF] text-white py-20 mb-20">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">Nuestros Servicios</h1>
          <p className="text-xl max-w-3xl mx-auto font-light">
            Contratistas generales - Remodelación y reparaciones - Comercial & Residencial
          </p>
        </div>
      </section>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Services Grid */}
        <div className="grid md:grid-cols-3 gap-8 mb-20">
          {services.map((service) => {
            const Icon = iconMap[service.icon];
            return (
              <Card
                key={service.id}
                className="group hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 overflow-hidden"
              >
                <div className="relative h-64 overflow-hidden">
                  <img
                    src={service.image}
                    alt={service.title}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent"></div>
                  <div className="absolute bottom-4 left-4">
                    <div className="bg-[#0057CB] p-3 rounded-lg">
                      <Icon className="w-6 h-6 text-white" />
                    </div>
                  </div>
                </div>
                <CardContent className="p-6">
                  <h3 className="text-2xl font-bold text-gray-900 mb-3">{service.title}</h3>
                  <p className="text-gray-600">{service.description}</p>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Benefits Section */}
        <section className="bg-gray-50 rounded-2xl p-8 md:p-12 mb-20">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 text-center mb-12">
            ¿Por Qué Elegirnos?
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {benefits.map((benefit, index) => (
              <div key={index} className="flex items-start space-x-3">
                <CheckCircle className="w-6 h-6 text-[#0057CB] flex-shrink-0 mt-1" />
                <span className="text-gray-700 text-lg font-light">{benefit}</span>
              </div>
            ))}
          </div>
        </section>

        {/* CTA Section */}
        <section className="text-center bg-gradient-to-r from-[#0057CB] to-[#38B6FF] text-white rounded-2xl p-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">¿Interesado en Nuestros Servicios?</h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto font-light">
            Contáctanos para una consulta gratuita - Renovation made easy!
          </p>
          <Link to="/contacto">
            <Button
              size="lg"
              className="bg-white hover:bg-gray-100 text-[#0057CB] font-semibold px-10 py-6 text-lg transition-all duration-300 hover:scale-105"
            >
              Solicitar Cotización
            </Button>
          </Link>
        </section>
      </div>
    </div>
  );
};

export default Services;
